require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./software-for-home-care-services.json") })
        }
      }, "path---software-for-home-care-services");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---software-for-home-care-services!./.cache/json/software-for-home-care-services.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---software-for-home-care-services!./.cache/json/software-for-home-care-services.json
// module chunks = 231608221292675